import api, { tokenManager } from '../../../core/api/client';

export const authService = {
  async signup(userData) {
    try {
      const response = await api.post('/auth/signup', userData);

      if (response.data.user && response.data.access_token) {
        tokenManager.setToken(response.data.access_token);
        tokenManager.setRefreshToken(response.data.refresh_token);
      }

      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async login(email, password) {
    try {
      const response = await api.post('/auth/login', {
        email,
        password,
      });

      const { access_token, refresh_token, user } = response.data;
      tokenManager.setToken(access_token);
      tokenManager.setRefreshToken(refresh_token);

      return { user, token: access_token };
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async getCurrentUser() {
    try {
      const response = await api.get('/auth/me');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async changePassword(currentPassword, newPassword) {
    try {
      const response = await api.post('/auth/change-password', {
        current_password: currentPassword,
        new_password: newPassword,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  async logout() {
    try {
      await api.post('/auth/logout');
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      tokenManager.clearTokens();
    }
  },

  async refreshToken() {
    try {
      const refreshToken = tokenManager.getRefreshToken();
      if (!refreshToken) {
        throw new Error('No refresh token available');
      }

      const response = await api.post('/auth/refresh', {
        refresh_token: refreshToken,
      });

      const { access_token, refresh_token: newRefreshToken } = response.data;
      tokenManager.setToken(access_token);
      tokenManager.setRefreshToken(newRefreshToken);

      return access_token;
    } catch (error) {
      tokenManager.clearTokens();
      throw error;
    }
  },
};
